import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { handleApiError } from "../Helper/actionHelper";
import {
  MASTER_DATA_UNIVERSITIES_SUCCESS,
  MASTER_DATA_UNIVERSITIES_LOADING,
  MASTER_DATA_UNIVERSITIES_FAILED,
  DIGILOCKER_GET_URL_SUCCESS,
  DIGILOCKER_GET_URL_LOADING,
  DIGILOCKER_GET_URL_FAILED,
  DIGILOCKER_RESPONSE_LOADING,
  DIGILOCKER_RESPONSE_SUCCESS,
  DIGILOCKER_RESPONSE_FAILED,
  DIGILOCKER_DATA_RESPONSE_LOADING,
  DIGILOCKER_DATA_RESPONSE_SUCCESS,
  DIGILOCKER_DATA_RESPONSE_FAILED,
  CHECK_DOC_RESPONSE_LOADING,
  CHECK_DOC_RESPONSE_SUCCESS,
  CHECK_DOC_RESPONSE_FAILED,
  UPLOAD_DIGI_DOC_LOADING,
  UPLOAD_DIGI_DOC_SUCCESS,
  UPLOAD_DIGI_DOC_FAILED,
  REMOVE_FILE_LOADING,
  REMOVE_FILE_SUCCESS,
  REMOVE_FILE_FAILED,
  SAVE_REASON_LOADING,
  SAVE_REASON_SUCCESS,
  SAVE_REASON_FAILED,
  RETRY_DIGILOCKER_LOADING,
  RETRY_DIGILOCKER_SUCCESS,
  RETRY_DIGILOCKER_FAILED
} from "../Constants/digiLockerConstants";

export const getDigiUniversityList = (payloadForQr, checkStatus) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: MASTER_DATA_UNIVERSITIES_LOADING });
      let requestData = {
        token: userLocalData.id,
        param: "master_ts_university"
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
    //   https://ibridge-uat.authbridge.com/idemo/GenericApi/masterData
    // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getAllTSModeName
      const { data } = await axios.post(FOLDERPATH +
        "/GenericApi/masterData",
        requestData,
        {
          headers: headers,
        }
      );
    //   handleApiMessages(data?.status, data?.message || data?.msg);
    //   if (data?.data?.dav_checks?.length) {
    //     const qrRequestData = {
    //       ...requestData,
    //       ...payloadForQr
    //     }
    //     const { data } = await axios.post(FOLDERPATH +
    //       "/CandidateApi/getDavQrForm",
    //       qrRequestData,
    //       {
    //         headers: headers,
    //       }
    //     );
    //     console.log("data,,,,....", data)
    //     handleApiMessages(data?.status, data?.message || data?.msg);
    //     dispatch({
    //       type: DAV_DATA_SUCCESS,
    //       payload: data,
    //     });
    //     if(checkStatus && data?.status?.toUpperCase() === 'SUCCESS') {
    //       await dispatch(getDAVStatus());
    //     }
    //   }
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error("errorMsg", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: MASTER_DATA_UNIVERSITIES_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      console.log('INSUFF_ERROR..', error)
  
      handleApiError(error);
    }
  };


  export const getDigiResponse = (tran_id, callback) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      let case_id = JSON.parse(localStorage.getItem('digiCaseId'));
      let trans_id = JSON.parse(localStorage.getItem('digiTransId'));
      dispatch({ type: DIGILOCKER_DATA_RESPONSE_LOADING });
      let requestData = {
        token: userLocalData.id,
        ts_trans_id: trans_id,
        initial_case_id: case_id
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
    //   https://ibridge-uat.authbridge.com/idemo/GenericApi/masterData
    // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getAllTSModeName
      const { data } = await axios.post(FOLDERPATH +
        "/CandidateApi/getDigilockerEduData",
        requestData,
        {
          headers: headers,
        }
      );
      localStorage.setItem('digilocker_data' , JSON.stringify(data));
    //   handleApiMessages(data?.status, data?.message || data?.msg);
    //   if (data?.data?.dav_checks?.length) {
    //     const qrRequestData = {
    //       ...requestData,
    //       ...payloadForQr
    //     }
    //     const { data } = await axios.post(FOLDERPATH +
    //       "/CandidateApi/getDavQrForm",
    //       qrRequestData,
    //       {
    //         headers: headers,
    //       }
    //     );
    //     console.log("data,,,,....", data)
    //     handleApiMessages(data?.status, data?.message || data?.msg);
        dispatch({
          type:  DIGILOCKER_DATA_RESPONSE_SUCCESS,
          payload: data,
        });
          // callback(data);
    //     if(checkStatus && data?.status?.toUpperCase() === 'SUCCESS') {
    //       await dispatch(getDAVStatus());
    //     }
    //   }
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error("errorMsg", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type:  DIGILOCKER_DATA_RESPONSE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      console.log('INSUFF_ERROR..', error)
  
      handleApiError(error);
    }
  };

  export const getCheckDocuments = (check_id) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: CHECK_DOC_RESPONSE_LOADING });
      let requestData = {
        token: userLocalData.id,
        param: "check_documents",
        check_id: check_id
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
    //   https://ibridge-uat.authbridge.com/idemo/GenericApi/masterData
    // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getAllTSModeName
      const { data } = await axios.post(FOLDERPATH +
        "/GenericApi/masterData",
        requestData,
        {
          headers: headers,
        }
      );
      
    //   handleApiMessages(data?.status, data?.message || data?.msg);
    //   if (data?.data?.dav_checks?.length) {
    //     const qrRequestData = {
    //       ...requestData,
    //       ...payloadForQr
    //     }
    //     const { data } = await axios.post(FOLDERPATH +
    //       "/CandidateApi/getDavQrForm",
    //       qrRequestData,
    //       {
    //         headers: headers,
    //       }
    //     );
    //     console.log("data,,,,....", data)
    //     handleApiMessages(data?.status, data?.message || data?.msg);
        dispatch({
          type:  CHECK_DOC_RESPONSE_SUCCESS,
          payload: data,
        });
          // callback(data);
    //     if(checkStatus && data?.status?.toUpperCase() === 'SUCCESS') {
    //       await dispatch(getDAVStatus());
    //     }
    //   }
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error("errorMsg", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type:  CHECK_DOC_RESPONSE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      console.log('INSUFF_ERROR..', error)
  
      handleApiError(error);
    }
  };


export const getDigiMoqList = (orgId, index, callback) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: MASTER_DATA_UNIVERSITIES_LOADING });
      let requestData = {
        token: userLocalData.id,
        master_org_id: orgId
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
    //   https://ibridge-uat.authbridge.com/idemo/GenericApi/masterData
    // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getAllTSModeName
      const { data } = await axios.post(FOLDERPATH +
        "/CandidateApi/getAllTSModeName",
        requestData,
        {
          headers: headers,
        }
      );
      if(data?.data){
        let optionsArr = []
        let resArr = []
        let res = data.data.map((item) => {
          resArr.push({
            name: item.doc_name,
            id: item.doc_type,
            data: item
          })
          return(
            optionsArr.push({
              label: item.doc_name,
              value: item
            })
          )
        })
        // console.log(optionsArr)
        localStorage.setItem('digiMOQ' , JSON.stringify(optionsArr));
        callback(optionsArr, resArr, index);
      }
    //   handleApiMessages(data?.status, data?.message || data?.msg);
    //   if (data?.data?.dav_checks?.length) {
    //     const qrRequestData = {
    //       ...requestData,
    //       ...payloadForQr
    //     }
    //     const { data } = await axios.post(FOLDERPATH +
    //       "/CandidateApi/getDavQrForm",
    //       qrRequestData,
    //       {
    //         headers: headers,
    //       }
    //     );
    //     console.log("data,,,,....", data)
    //     handleApiMessages(data?.status, data?.message || data?.msg);
    //     dispatch({
    //       type: DAV_DATA_SUCCESS,
    //       payload: data,
    //     });
    //     if(checkStatus && data?.status?.toUpperCase() === 'SUCCESS') {
    //       await dispatch(getDAVStatus());
    //     }
    //   }
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error("errorMsg", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: MASTER_DATA_UNIVERSITIES_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      console.log('INSUFF_ERROR..', error)
  
      handleApiError(error);
    }
};

export const getDigiLockerFields = (univId, orgID, callback) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: MASTER_DATA_UNIVERSITIES_LOADING });
    let requestData = {
      token: userLocalData.id,
      type_master_id: univId,
      org_id: orgID
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
  // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getAllTSModeNameParams
    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/getAllTSModeNameParams",
      requestData,
      {
        headers: headers,
      }
    );
    if(data?.data){
      // let optionsArr = []
      // let res = data?.data.map((item) => {
      //   return(
      //     optionsArr.push(item)
      //   )
      // })
      // console.log(optionsArr)
      // localStorage.setItem('' , JSON.stringify(optionsArr));
      callback(data?.data, data?.add_more);
    }
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error("errorMsg", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: MASTER_DATA_UNIVERSITIES_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};


export const verifyDigiLockerDocuments = (callback) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: DIGILOCKER_GET_URL_LOADING });
    let requestData = {
      token: userLocalData.id,
      // digi_doc_params: payload
    };
    // console.log(payload);
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getEduDigilockerLinkApi
    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/getEduDigilockerLinkApi",
      requestData,
      {
        headers: headers,
      }
    );
    if(data?.data){
      let url = data?.data?.url;
      let trans_id = data?.ts_trans_id
      callback(url,trans_id);
    }
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error("errorMsg", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: DIGILOCKER_GET_URL_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};

// export const digiLockerCallbackGetData = (payload, callback) => async (dispatch) => {
//   try {
//     let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
//     dispatch({ type: MASTER_DATA_UNIVERSITIES_LOADING });
//     let requestData = {
//       token: userLocalData.id,
//       digi_doc_params: payload
//     };
    
//     const headers = {
//       "Content-Type": "application/json",
//       Username: "ibridge",
//       Password: "ibridge@2020",
//     };
//     // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getEduDigilockerLinkApi
    
//     const { data } = await axios.post(FOLDERPATH +
//       "/CandidateApi/getEduDigilockerLinkApi",
//       requestData,
//       {
//         headers: headers,
//       }
//     );
//     // debugger
//     // if(data?.data){
//     //   let optionsArr = []
//     //   let res = data.data.map((item) => {
//     //     return(
//     //       optionsArr.push({
//     //         label: item.doc_name,
//     //         value: item
//     //       })
//     //     )
//     //   })
//     //   // console.log(optionsArr)
//     //   localStorage.setItem('digiMOQ' , JSON.stringify(optionsArr));
//     //   callback(optionsArr);
//     // }
//     handleApiError(data); //in case API return 200 with error details
//   } catch (error) {
//     toast.error("errorMsg", {
//       position: "top-right",
//       autoClose: 5000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//     });
//     dispatch({
//       type: MASTER_DATA_UNIVERSITIES_FAILED,
//       payload:
//         error.response && error.response.data.message
//           ? error.response
//           : error.response,
//     });
//     console.log('INSUFF_ERROR..', error)

//     handleApiError(error);
//   }
// };


// [
//   "003386" = {
//       "DGCER":{
//               "RROLL":"wewee",
//               "REGNO":"sdd",
//               "YEAR" : "2017"
//               }
//         }, 
//   "003386" = {
//           "DGCER":{
//                   "RROLL":"wewee",
//                   "REGNO":"sdd",
//                   "YEAR" : "2017"
//                   }
//             },
// ]

export const uploadDigiEduDocs =
(record={}, file) =>
async (dispatch) => {
  try {
    
    dispatch({ type: UPLOAD_DIGI_DOC_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    record.token=userLocalData.id;

    console.log(record);

    let formData = new FormData();
    Object.keys(record).map((k) => {
      formData.set(k, record[k]);
    });
    for (let i = 0; i < record?.check_documents?.length; i++) {
      formData.append(`${"check_documents"}[${i}]`, record.check_documents[i]);
    }



    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/uploadFiles",
      formData,
      {
        headers,
      }
    );
    dispatch({
      type: UPLOAD_DIGI_DOC_SUCCESS,
      payload: data,
    });
    if (data) {
      if(record?.docid!="")
      {const msg = "Uploaded Successfully";
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });}
      //callback(data?.data);
    } else {
      alert("Invalid file");
    }

    // handleApiError(data);
  } catch (error) {
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: UPLOAD_DIGI_DOC_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const removeFile =
  (record, callback=()=>{}) =>
  async (dispatch) => {
    try {
      dispatch({ type: REMOVE_FILE_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      const requestData = {
        token: userLocalData.id,
        ...record,
      };

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/removeFiles",
        requestData,
        {
          headers,
        }
      );

      await dispatch({
        type: REMOVE_FILE_SUCCESS,
        payload: data,
      });
     
      const msg = "Removed Successfully";

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      callback(data);
      return data;
    } catch (error) {
      toast.error("Something went wrong", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: REMOVE_FILE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
    }
  };

// export const saveDigiReasonApi = (payload, callback=()=>{}) =>
// async (dispatch) => {debugger
//   try {
//     dispatch({ type: SAVE_REASON_LOADING });

//     let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

//     const requestData = {
//       token: userLocalData.id,
//       ...payload,
//     };

//     const headers = {
//       "Content-Type": "application/json",
//       Username: "ibridge",
//       Password: "ibridge@2020",
//     };

//     const { data } = await axios.post(
//       FOLDERPATH + "CandidateApi/saveDigilockerReason",
//       requestData,
//       {
//         headers,
//       }
//     );

//     await dispatch({
//       type: SAVE_REASON_SUCCESS,
//       payload: data,
//     });
   
//     const msg = "Saved Successfully";

//     toast.success(msg, {
//       position: "top-right",
//       autoClose: 5000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//     });
//     callback(data);
//     return data;
//   } catch (error) {
//     toast.error("Something went wrong", {
//       position: "top-right",
//       autoClose: 5000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//     });
//     dispatch({
//       type: SAVE_REASON_FAILED,
//       payload:
//         error.response && error.response.data.message
//           ? error.response
//           : error.response,
//     });
//   }
// };

export const saveDigiReasonApi = (payload, callback=()=>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: SAVE_REASON_LOADING });
    let requestData = {
      ...payload,
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
  // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getAllTSModeNameParams
    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/saveDigilockerReason",
      requestData,
      {
        headers: headers,
      }
    );
    // if(data?.data){
    //   // let optionsArr = []
    //   // let res = data?.data.map((item) => {
    //   //   return(
    //   //     optionsArr.push(item)
    //   //   )
    //   // })
    //   // console.log(optionsArr)
    //   // localStorage.setItem('' , JSON.stringify(optionsArr));
    //   callback(data?.data, data?.add_more);
    // }
    callback(data);
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: SAVE_REASON_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};

export const retryApi = (callback=()=>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    let case_id = JSON.parse(localStorage.getItem('digiCaseId'));
    dispatch({ type: RETRY_DIGILOCKER_LOADING });
    let requestData = {
      inital_case_id: case_id,
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
  // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getAllTSModeNameParams
    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/retryDigilocker",
      requestData,
      {
        headers: headers,
      }
    );
    // if(data?.data){
    //   // let optionsArr = []
    //   // let res = data?.data.map((item) => {
    //   //   return(
    //   //     optionsArr.push(item)
    //   //   )
    //   // })
    //   // console.log(optionsArr)
    //   // localStorage.setItem('' , JSON.stringify(optionsArr));
    //   callback(data?.data, data?.add_more);
    // }
    callback(data);
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: RETRY_DIGILOCKER_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};

export const getMasterUniversityEducation = (payload, callback=()=>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    // dispatch({ type: SAVE_REASON_LOADING });
    let requestData = {
      ...payload,
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
  // https://ibridge-uat.authbridge.com/idemo/CandidateApi/getAllTSModeNameParams
    const { data } = await axios.post(FOLDERPATH +
      "/GenericApi/getMasterUniversity",
      requestData,
      {
        headers: headers,
      }
    );
    if(data?.data){
      // let optionsArr = []
      // let res = data?.data.map((item) => {
      //   return(
      //     optionsArr.push(item)
      //   )
      // })
      // console.log(optionsArr)
      // localStorage.setItem('' , JSON.stringify(optionsArr));
      callback(data?.data, data?.add_more);
    }
    // callback(data);
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    // dispatch({
    //   type: SAVE_REASON_FAILED,
    //   payload:
    //     error.response && error.response.data.message
    //       ? error.response
    //       : error.response,
    // });
    console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};

export const getMRLNonDigiDocument = (payload = {}, checkName) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: CHECK_DOC_RESPONSE_LOADING });
    let requestData = {
      token: userLocalData.id,
      ...payload
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH +
      "/InstantNid/getMRLRequiredDocument",
      requestData,
      {
        headers: headers,
      }
    );
    // This needs to be done form api side
    const formattedResponse  = {
      "check_name" : {
        [payload.check_id] : checkName 
      },
      "data" : {
        [payload.check_id] : data?.data?.required_documents ||data
      }
    }
    
      dispatch({
        type:  CHECK_DOC_RESPONSE_SUCCESS,
        payload: formattedResponse,
      });

    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error("errorMsg", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type:  CHECK_DOC_RESPONSE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};
